import { render } from "./PaymentComplete.vue?vue&type=template&id=31fc52e8&ts=true"
import script from "./PaymentComplete.vue?vue&type=script&lang=ts"
export * from "./PaymentComplete.vue?vue&type=script&lang=ts"

import "./PaymentComplete.vue?vue&type=style&index=0&id=31fc52e8&lang=scss"

import exportComponent from "/github/workspace/customer/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__